/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
/* eslint-disable operator-linebreak */
import Utility from './Utility';
import { ls } from './LocalStorage';

class Authorization {
  static ROLE_CONFIG_MANAGER = 'CONFIG MANAGER';

  static ROLE_ADMIN = 'ROOTADMIN';

  constructor() {
    this.authUser = null;
    this.authUserId = null;
    this.authRole = null;
    this.refreshRate = null;
  }

  /**
   * set auth user details to class property
   *
   * @return void
   */
  setAuthUser() {
    const authUser = ls.getItem('auth_user');

    if (authUser) {
      try {
        this.authUser = JSON.parse(authUser);
      } catch (error) {
        console.error('Failed to parse auth_user:', error);
        this.authUser = null;
      }
    }
  }

  /**
   * set auth user details to class property
   *
   * @return void
   */
  getLocalRefreshRate() {
    this.refreshRate = JSON.parse(ls.getItem('refreshRate'));
    if (this.refreshRate) {
      return this.refreshRate * 1000;
    }

    return undefined;
  }

  /**
   * check is active user is logged in
   *
   * @return boolean
   * Authentication itself is handled by the DICV_SESSION cookie.
   * auth_user only contains frontend user/profile information.
   */
  isLoggedIn() {
    return typeof ls.getItem('auth_user') === 'string';
    //
  }

  /**
   * Once user is logged in, redirect the user to view permission page
   * By default will redirect to 'dashboard' page.
   * If user does not have permission to access dashboard page,
   * find the view permission page from the his permission object
   * and redirect the user to respective path.
   *
   * @param {*} props
   */
  redirectAfterLogin(props) {
    ls.setItem('refreshRate', 60);

    const isAdminRole = this.getAuthUserRole();
    // const userId = this.getAuthUserId();
    let redirectPath = '/track-trace';

    if (isAdminRole === 'ROOTADMIN') {
      redirectPath = '/profile';
    } else if (isAdminRole === 'SUPERADMIN') {
      redirectPath = '/profile';
    } else if (isAdminRole === 'CSSUPPORT') {
      redirectPath = '/cssupport';
    }

    ls.setItem('showDTCPopup', true);

    // Use React Router history for client-side navigation if available
    if (props && props.history) {
      props.history.push(redirectPath);
    } else {
      // Fallback to window.location for cases without history object
      window.location.assign(`${window.location.origin}${redirectPath}`);
    }
  }

  /**
   * check user is having the expected role
   *
   * @param role
   * @return boolean
   */
  isUserRole(role) {
    const user = this.getAuthUser();

    return (
      Utility.isObject(user) &&
      Utility.isObject(user.roles) &&
      user.roles[0] === role
    );
  }

  /**
   * check logged user is admin
   *
   * @return boolean
   */
  isAdmin() {
    return this.isUserRole(Authorization.ROLE_ADMIN);
  }

  /**
   * check logged user is config manager
   *
   * @return boolean
   */
  isConfigManager() {
    return this.isUserRole(Authorization.ROLE_CONFIG_MANAGER);
  }

  /**
   * get logged in user details
   *
   * @return boolean
   * NOTE:
   * This does NOT return an access token.
   * Access tokens are no longer stored/used by the frontend.
   */
  getAuthUser() {
    if (this.isLoggedIn() && !this.authUser) {
      this.setAuthUser();
    }

    return this.authUser;
  }

  /**
   * get auth user identifier
   *
   * @return int
   */
  getAuthUserId() {
    const user = this.getAuthUser();

    return Utility.isObject(user) && user.userId ? user.userId : 0;
  }

  /**
   * get auth user role
   *
   * @return string
   */
  getAuthUserRole() {
    const user = this.getAuthUser();

    if (Utility.isObject(user) && user.userRole) {
      return user.userRole;
    }

    if (
      Utility.isObject(user)
      && Array.isArray(user.roles)
      && user.roles.length
    ) {
      return user.roles[0];
    }

    if (Utility.isObject(user) && user.role) {
      return user.role;
    }

    return '';
  }

  /**
   * Get authentication access token
   *
   * @return string
   * Authentication is session-cookie based.
   * The browser sends DICV_SESSION automatically.
   */
  getAccessToken() {
    return null;
  }

  /**
   * Access token is NO LONGER stored in frontend.
   *
   * Kept only for backward compatibility in case some old
   * component still calls setAccessToken().
   */
  setAccessToken() {
    console.warn(
      'setAccessToken() is deprecated. Authentication now uses DICV_SESSION cookie.'
    );
  }

  /**
   * login the user by setting it in local storage
   *
   * @return boolean
   * using the HttpOnly DICV_SESSION cookie.
   */
  login(data) {
    if (typeof Storage !== 'undefined') {
      ls.removeItem('auth_user');
      ls.setItem('auth_user', JSON.stringify(data));
      ls.setItem('expires_on', String(data.tokenExpirationTime));

      this.authUser = data;
    } else {
      console.error('local storage is not supported');
    }
  }

  /**
   * get logged in user details
   *
   * @return boolean
   */
  logout() {
    // clear URL stored in localStorage
    if (typeof Storage !== 'undefined') {
      ls.removeItem('auth_user');
      ls.removeItem('userProfile');
      ls.removeItem('refreshRate');
      ls.removeItem('showDTCPopup');
      ls.removeItem('guided_demo');
      ls.removeItem('firstName');
      ls.removeItem('theme');
      ls.removeItem('id_token');
      ls.removeItem('state');
      ls.removeItem('refresh_token');
      ls.removeItem('userName');
      ls.removeItem('expiryAcknowledged');
      ls.removeItem('expires_on');
      ls.removeItem('loginTickerAcknowledged');
      ls.removeItem('csSupportRequestedLoggedInRole');
      ls.removeItem('csSupportRequestedLoggedInUserId');
      ls.removeItem('csSupportRequestedLoggedInUserName');
      sessionStorage.clear();
      // this.emptyCache();
      // this.clearCookies();
      window.location.assign(`${window.location.origin}/`);

      this.authUser = null;
      this.authUserId = null;
      this.authRole = null;
    } else {
      console.error('local storage is not supported');
    }
  }

  emptyCache() {
    if ('caches' in window) {
      caches.keys().then(names => {
        // Delete all the cache files
        names.forEach(name => {
          caches.delete(name);
        });
      });

      // // Makes sure the page reloads. Changes are only visible after you refresh.
      // window.location.reload(true);
    }
  }

  clearCookies() {
    const cookies = document.cookie.split(';');
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < cookies.length; i += 1) {
      const cookie = cookies[i];
      const eqPos = cookie.indexOf('=');
      const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    }
  }
}

export default new Authorization();
